<template>
  <div>
    <ul class="message_list" v-if="data.list">
      <li class="message_item" v-for="(item, i) in data.list" :key="i">
        <div class="message_twig">
          <div class="user_img">
            <img :src="item.img_url" alt="" />
          </div>
          <div>
            <h3 class="user_name">
              {{ item.name ? item.name : item.nickname }}
              <span class="user_job">{{ item.duties }}</span>
              <img v-if="item.authent*1==1" class="attestation" :src="hrefurl+'/public/icon/attestation.jpg'" alt=""/>
            </h3>
            <p class="user_firm">
              {{ item.corpname }}
            </p>
          </div>
        </div>
        <p class="message_content" @click="popup(item.id)">
          {{ item.content }}
        </p>
        <div class="message_img_list">
          <div
            class="message_img_item"
            v-for="(imgitem, i) in item.content_img"
            :key="'img' + i"
          >
            <el-image
              style="width: 100%; height: 100%"
              fit="cover"
              :src="imgitem.img_url"
              :preview-src-list="[imgitem.img_url]"
            >
            </el-image>
          </div>
        </div>
        <div class="message_handle">
          <span class="message_discuss" @click="popup(item.id)" @mouseover="messageimg=i" @mouseout="messageimg=null">
            <img :src="messageimg==i?hrefurl+'/public/icon/message_1.png':hrefurl+'/public/icon/message.png'" />
            {{item.comment}}
          </span>
          <span class="message_traffic" @mouseover="giveimg=i" @mouseout="giveimg=null">
            <img :src="i==giveimg?hrefurl+'/public/icon/give_1.png':hrefurl+'/public/icon/give.png'" />
            {{item.click}}
          </span>
        </div>
      </li>
      <div v-if="this.data.list.length > 0">
        <div
          class="addLoading"
          v-if="
            data.list.length !== 0 && data.list.length % data.pageListnum == 0
          "
          @click="addsupply"
        >
          点击加载更多
          <img v-if="switchLoading" :src="hrefurl+'/public/home/icon/icon/loading.gif'" />
        </div>
        <div class="addLoading" v-else>我是有底线的！！！</div>
      </div>
      <div v-else class="zanwu">
        <div>
          <img :src="hrefurl+'/public/icon/without.png'" />
        </div>
        <p class="p">暂无信息可查看，点击右侧发布信息发布吧！</p>
      </div>
    </ul>
    <el-dialog
      title="详情"
      :visible.sync="centerDialogVisible"
      width="650px"
      top="3vh"
      :before-close="beforeClose"
      center
    >
      <div class="comment" v-if="detailsList[0]">
        <div class="userMessage">
          <div>
            <img :src="detailsList[0].img" alt="" />
            <span class="name">{{
              detailsList[0].name
                ? detailsList[0].name
                : detailsList[0].nickname
            }}</span>
            <span>{{ detailsList[0].duties }}</span>
            <span>{{ detailsList[0].corpname }}</span>
            <span>{{ detailsList[0].ctime }}</span>
          </div>
        </div>
        <p>{{ detailsList[0].content }}</p>
        <div v-if="detailsList[0].address" class="address">
          <img class="imgIcon" :src="hrefurl+'/public/icon/address.png'" />
          {{ detailsList[0].address }}
        </div>
        <div
          v-if="detailsList[0].supply_img"
          class="commentImg"
          ref="commentImg"
        >
          <div class="userImg" ref="userImg">
            <div v-for="(item, i) in detailsList[0].supply_img" :key="i">
              <img :src="item.img_url" :alt="item.img_info_cn" />
            </div>
          </div>
        </div>
      </div>
      <div class="area">
        <ul class="areaList" v-if="detailsList[1]">
          <li
            class="areaItem"
            v-for="(areaItem, i) in detailsList[1]"
            :key="'area' + i"
          >
            <img :src="areaItem.img" alt="" />
            <div class="con">
              <span class="areaName"
                >{{ areaItem.name ? areaItem.name : areaItem.nickname }}：</span
              >
              <span class="areaContent">{{ areaItem.comment }}</span>
              <p>
                <span class="areaTime">{{ areaItem.ctime }}</span>
                <span class="praise">99</span>
              </p>
            </div>
            <div class="cancel" style="display: none">
              <el-popconfirm
                icon="el-icon-info"
                icon-color="red"
                confirm-button-text="Confirm"
                cancel-button-text="Cancel"
                title="Are you sure to cancel?"
                @onConfirm="del(areaItem.id)"
              >
                <el-button slot="reference" type="danger">删除</el-button>
              </el-popconfirm>
            </div>
          </li>
        </ul>
        <div class="discussArea">
          <textarea
            class="discuss"
            placeholder="请输入内容"
            name=""
            id=""
            cols="30"
            rows="10"
            v-model="content"
          ></textarea>
          <button @click="sendComment">发送</button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { reqComments, reqComment } from "../../../api";
export default {
  props: ["data"],
  data() {
    return {
      switchLoading: false,
      centerDialogVisible:false,
      detailsList:[],//详情信息
      content:"",//输入评论内容
      current:'',
      messageimg:null,
      giveimg:null,
      status:{messageimg:[],giveimg:[]}
    };
  },
  mounted() {
    if (sessionStorage.getItem('negotiation')) {//首页 洽谈
      let obj = JSON.parse(sessionStorage.getItem('negotiation'))
      this.centerDialogVisible = true
      this.popup(obj.id)
    }
  },
  methods: {
    addsupply() {
      this.$emit("supplyCut", 1, this.data.page * 1 + 1, 1, false, true);
    },
    beforeClose(){
      this.content = ''
      this.centerDialogVisible=false
    },
    del(id){//删除评论
      console.log(id);
      alert("id")
    },
    async sendComment(){//发送评论
      let cent = this.content.trim()
      let isLogin = this.jump(this)
      // 当前用户id：this.user.id;
      //当前选中动态的id：this.current
      if (!cent.length&&!isLogin) return
      // 发送请求
      const response = await reqComments({sid:this.current,comment:this.content})
      if (response.code==1) {
        this.success(this,'评论提交成功，请耐心等待审核。。。')
        this.content=""
      } else if(response.code==0) {
        this.err(this,'评论失败，请稍后重试。。。')
      }else if(response.code==2){
        this.err(this,'登录失效，请重新登录。。。')
        // this.jump(this)
        this.$store.dispatch("outLogin")
        this.$store.dispatch("dialog",true)
      }
    },
    async popup(id){
      const response = await reqComment(id)
      if (response.code==1) {
        this.detailsList=response.msg
        this.centerDialogVisible=true
        this.current = id
      }
    },
    adds(i){
      this.status.giveimg[i]=true
    }
  },
};
</script>

<style scoped>

.message_item {
  padding: 14px 44px 0 64px;
  background-color: white;
  margin-bottom: 2px;
}
.message_item:hover{
  box-shadow: 3px 3px 8px 0 rgb(0 0 0 / 34%);
}
.message_twig {
  display: flex;
  padding-bottom: 14px;
}

.user_img {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 24px;
}
.user_name {
  font-size: 18px;
  color: #333;
  line-height: 28px;
  padding-top: 6px;
}
.attestation{
  width: 80px;
  height: 20px;
  margin-left: 16px;
}
.user_firm {
  font-size: 18px;
  color: #666;
}
.message_content {
  font-size: 14px;
  color: #999;
  line-height: 22px;
  padding-bottom: 14px;
  width: 80%;
  cursor: pointer;
}
.message_img_list {
  display: flex;
  padding-bottom: 14px;
}
.message_img_item {
  width: 174px;
  height: 98px;
  margin-left: 24px;
}
.message_img_item:first-child {
  margin-left: 0;
}
.message_img_item img {
  object-fit: cover;
}
.message_img_item >>> .el-image-viewer__canvas img {
  /*大图展示图片样式 */
  object-fit: scale-down;
}
.message_img_item>>>.el-image-viewer__mask{
  opacity: .8;
}
.message_img_item>>>.el-image-viewer__close{
  color: white;
}
.message_handle {
  padding-top: 8px;
  padding-bottom: 8px;
  text-align: end;
}
.message_handle img {
  width: 34px;
  vertical-align: middle;
}
.message_handle > span {
  display: inline-block;
  margin-left: 34px;
  font-size: 14px;
  color: #333;
  vertical-align: middle;
  cursor: pointer;
}
.message_handle > span:first-child {
  margin-left: 0;
}
/*  */
.addLoading {
  text-align: center;
  font-size: 18px;
  padding: 20px 0;
  cursor: pointer;
}
.addLoading img {
  width: 20px;
}
.zanwu {
  width: 876px;
  text-align: center;
  font-size: 18px;
}
.zanwu > div {
  width: 200px;
  margin: 40px auto 20px;
}
</style>
<style scoped>
/* 详情内容 */
  .userMessage img{
    width: 30px;
    overflow: hidden;
    border-radius: 50%;
  }
  .userMessage .name{
    margin: 0 10px;
  }
  .comment{
    padding-bottom: 20px;
    border-bottom: 1px solid #aaa;
  }
  .comment>p{
    padding: 8px 14px;
  }
  .address{
    padding: 8px;
  }
  .address img{
    width: 20px;
  }
  .userImg>div{
    width: 160px;
    height: 146px;
    display: inline-block;
    padding-left: 14px;
  }
  /* 评论列表 satrt */
  .supplyMain>>>.el-dialog{
    max-width: 880px;
  }
  .area{
    width: 100%;
    max-height: 400px;
    /* height: 300px; */
    padding: 10px 20px 0;
    overflow-y: auto;
  }
  .areaItem{
    border-top: 1px dashed #aaa;
    padding: 10px 0;
    position: relative;
  }
  .areaItem:first-child{
    border: none;
  }
  .areaItem>.con{
    padding: 0 40px 10px;
    /* padding-bottom: 10px; */
    width: 100%;
  }
  .areaItem img{
    width: 34px;
    float: left;
  }
  .areaName{
    color: #6e6e6e;
    font-size: 14px;
  }
  .areaTime{
    color: #6e6e6e;
    font-size: 12px;
  }
  .areaContent{
    /* padding: 0 30px 20px; */
    font-size: 14px;
  }
  .praise{
    float: right;
    display: none;
  }
  .cancel{
    position: absolute;
    right: 2px;
    /* top: 5px; */
    bottom: 10px;
  }
  .cancel>>>.el-button{
    padding: 6px 8px;
  }
  .discussArea{
    position: relative;
    height: 120px;
    margin: 0 4px;
    overflow: hidden;
  }
  .discuss{
    border-radius: 6px;
    border: 1px solid #dcdfe6;
    color: #606266;
    width: 100%;
    height: 100%;
    padding: 20px;
    font-size: 14px;
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  }
  .discuss:focus{
    outline: none;
    border-color: #409eff;
  }
  .discussArea>button{
    position: absolute;
    right: 10px;
    bottom: 2px;
    padding: 6px 18px;
    border-radius: 4px;
    outline: none;
    border: 1px solid #dcdfe6;
    background-color: white;
    cursor: pointer;
  }
  .discussArea>button:hover{
    color: #409eff;
    border-color: #409eff;
  }
  
  /* 评论列表 end */
</style>